import type {
    CollectionWithCreationDate,
    CollectionWithId,
    CollectionWithOptionalCreationDate,
    WithCollections,
    WithCollectionsOptionalCreationDate,
} from '@pressreader/social-types';

import type { CollectionDtoWithCreationDate, CollectionDtoWithOptionalCreationDate, CollectionWithIdDto, WithCollectionsDto } from '../types';

function mapCollection({ id }: CollectionWithIdDto): CollectionWithId;
function mapCollection({ id, createdDate }: CollectionDtoWithOptionalCreationDate & { createdDate: undefined }): CollectionWithId;
function mapCollection({
    createdDate,
    id,
}: CollectionDtoWithOptionalCreationDate): typeof createdDate extends undefined ? CollectionWithId : CollectionWithCreationDate;
function mapCollection({ createdDate, id }: CollectionDtoWithCreationDate): CollectionWithCreationDate;
function mapCollection({
    createdDate,
    id,
}: CollectionDtoWithCreationDate | CollectionDtoWithOptionalCreationDate): CollectionWithCreationDate | CollectionWithOptionalCreationDate {
    if (!createdDate) {
        return { id };
    }
    return { createdDate: new Date(createdDate), id };
}

function mapCollectionsDto<T extends CollectionDtoWithCreationDate>(collectionsDto: WithCollectionsDto<T>): WithCollections;
function mapCollectionsDto<T extends CollectionDtoWithOptionalCreationDate>(
    collectionsDto: WithCollectionsDto<T>,
): WithCollectionsOptionalCreationDate;
function mapCollectionsDto<T extends CollectionDtoWithCreationDate | CollectionDtoWithOptionalCreationDate>(
    collectionsDto: WithCollectionsDto<T>,
): T extends CollectionDtoWithCreationDate ? WithCollections : WithCollectionsOptionalCreationDate {
    return {
        collections: collectionsDto.collections.map(mapCollection),
    };
}

export { mapCollectionsDto };
